export default "__VITE_ASSET__641eca84__"